<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!-- eslint-disable vue/no-v-html -->
  <span
    :style="rotate ? `transform: rotate(${rotate}deg)` : ''"
    class="tw-inline-flex tw-grow-0"
    v-bind="$attrs"
    v-html="svg"
  ></span>
  <!-- eslint-enable vue/no-v-html -->
</template>

<script setup lang="ts">
import { computed, withDefaults, defineProps } from 'vue';
import octicons from '@primer/octicons';

interface Props {
  icon: string;
  rotate?: string;
  height?: string | number;
  width?: string | number;
}

const props = withDefaults(defineProps<Props>(), {
  rotate: '',
});

const svg = computed(() => {
  const heightAndWidth = {
    ...(props.height ? { height: props.height } : {}),
    ...(props.width ? { width: props.width } : {}),
  };
  return octicons[props.icon].toSVG({
    ...heightAndWidth,
    fill: 'currentColor',
    class: 'tw-max-h-full',
  });
});
</script>
